import React, { ReactElement, useState } from 'react';
import { RadioboxGroupContextProvider } from './context';

export interface RadioGroupProps {
  /** 选中的条目 */
  defaultValue?: string;
  /** 是否禁用整组 */
  disabled?: boolean;
  name?: string;
  /** 状态改变时的回调 */
  onChange?: (event: string | number) => void;
  children?: ReactElement;
}

export const RadioboxGroup = (props: RadioGroupProps): ReactElement => {
  const { children, defaultValue = '', disabled, name, onChange } = props;

  const [checkedItem, setCheckedItem] = useState(defaultValue as any);

  const onRadioboxChange = (event: { value: string | number; select: boolean }): void => {
    const { value: val, select } = event;

    if (select) {
      setCheckedItem(val);
      onChange && onChange(val);
    }
  };

  return (
    <div className="Radiobox-group">
      <RadioboxGroupContextProvider
        value={{
          defaultValue: checkedItem,
          disabled,
          name,
          onChange: onRadioboxChange,
        }}
      >
        {children}
      </RadioboxGroupContextProvider>
    </div>
  );
};
